import { mapGetters } from 'vuex';
import productHistorySushi from '@/components/product-history-sushi/product-history-sushi.vue';
import tradeHistorySushi from '@/components/trade-history-sushi/trade-history-sushi.vue';
import sushiMarketLinksToggle from '../../components/sushi-market-links-toggle/sushi-market-links-toggle.vue';

export default {
  components: {
    productHistorySushi,
    tradeHistorySushi,
    sushiMarketLinksToggle,
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/pages/sushi-market-history/sushi-market-history.js